import type { ResumeData } from '../../lib/types';

export default function ProfessionalMemberships({ data }: { data: ResumeData }) {
  const items = data.professionalMemberships ?? [];
  if (items.length === 0) return null;
  return (
    <section className="container-fluid">
      <h2>Professional Memberships</h2>
      <div className="row">
        <div className="col-sm-12">
          <ul>
            {items.map((m, i) => (
              <li key={i}>{m}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
